import { Grid, IconButton, Typography } from '@material-ui/core';
import { IStoreState, ThunkDispatch } from '../../modules';
import React, { Component, Fragment } from 'react';
import { Record, TraceLogState, clearRecords, setViewerVisibility } from '../../modules/tracelog';
import { Theme, WithStyles, createStyles, withStyles } from '@material-ui/core/styles';
import { faFeatherAlt, faScroll, faTimes } from '@fortawesome/free-solid-svg-icons';

import ExchangesList from './ExchangesList';
import ExchangesToolbar from './ExchangesToolbar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { List } from 'immutable';
import Viewer from './viewers/Viewer';
import { bindActionCreators } from 'redux';
import classnames from 'classnames';
import { connect } from 'react-redux';

const styles = (theme: Theme) => createStyles({
  root: {
    height: '100vh'
  },
  rootEmpty: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    '& > *': {
      marginBottom: theme.spacing(1)
    }
  },
  traceLogIcon: {
    marginBottom: theme.spacing(4)
  },
  traceLogIconFeather: {
    '& path': {
      stroke: 'white',
      strokeWidth: '1.5rem'
    }
  },
  closeSymbol: {
    opacity: 0.5,
    position: 'absolute',
    top: 0,
    right: 0,
    margin: theme.spacing(2)
  },
  leftPane: {
    overflowY: 'auto',
    height: '100vh',
    borderRight: '1px solid rgba(0, 0, 0, 0.12)',
    display: 'block',
    [theme.breakpoints.up('md')]: {
      height: '100%',
    },
    [theme.breakpoints.down('sm')]: {
      '&$activeItem': {
        display: 'none'
      }
    }
  },
  rightPane: {
    overflowY: 'hidden',
    height: '100vh',
    display: 'none',
    [theme.breakpoints.up('md')]: {
      height: '100%',
      display: 'block',
    },
    [theme.breakpoints.down('sm')]: {
      '&$activeItem': {
        display: 'block'
      }
    }
  },
  activeItem: {

  },
  filterStatus: {
    color: '#999',
    fontStyle: 'italic',
    fontSize: '0.8rem',
    textAlign: 'center',
  },
});

type State = {
  filterFn: (records: List<Record>) => List<Record>
}

class ExchangesComponent extends Component<Props>{

  state: State = {
    filterFn: (x: List<Record>) => x
  }

  setFilterFn = (filterFn: (records: List<Record>) => List<Record>) => {
    this.setState({
      filterFn
    })
  }

  render() {
    const { classes, clearRecords, tracelog, setViewerVisibility } = this.props
    const { filterFn } = this.state

    const filteredRecords = filterFn(tracelog.records)
    return (
      <Fragment>
        {tracelog.records.size === 0 ?
          <div className={classes.rootEmpty}>
            <IconButton onClick={() => setViewerVisibility(false)} className={classes.closeSymbol}>
              <FontAwesomeIcon icon={faTimes} size="2x" fixedWidth />
            </IconButton>
            <span className={"fa-layers fa-fw fa-4x " + classes.traceLogIcon}>
              <FontAwesomeIcon icon={faScroll} transform="left-5 down-2" />
              <FontAwesomeIcon icon={faFeatherAlt} transform="right-5 shrink-2 up-6" color="gray" className={classes.traceLogIconFeather} />
            </span>
            <Typography variant="subtitle2">Trace log is currently empty</Typography>
            <Typography variant="subtitle2">Generate some SOAP or SDK calls to view them here!</Typography>
          </div>
          : <Grid container className={classes.root}>
            <Grid item xs={12} md={4} lg={3} className={classnames(classes.leftPane, tracelog.activeItem ? classes.activeItem : null)}>
              <ExchangesToolbar fnClear={clearRecords} fnSetFilterFn={this.setFilterFn} />
              {tracelog.records.size > filteredRecords.size &&
                <div className={classes.filterStatus}>
                  Showing {filteredRecords.size} of {tracelog.records.size} exchanges
              </div>
              }
              <ExchangesList records={filteredRecords} />
            </Grid>
            <Grid item xs={12} md={8} lg={9} className={classnames(classes.rightPane, tracelog.activeItem ? classes.activeItem : null)}>
              <Viewer item={tracelog.activeItem} />
            </Grid>
          </Grid>
        }
      </Fragment>
    )
  }
}

const mapStateToProps = ({ intl }: IStoreState) => ({
  intl,
})

const mapDispatchToProps = (dispatch: ThunkDispatch) =>
  bindActionCreators(
    {
      clearRecords,
      setViewerVisibility,
    }, dispatch
  )

interface Props extends WithStyles<typeof styles>, ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps> {
  tracelog: TraceLogState
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ExchangesComponent))